<template>
  <div>
    <vs-popup :active.sync="active" title="История генерации исходящего реестра Сбербанка">
      <div class="flex justify-between items-center">
        <div class="mb-4 flex items-center">
          <div class="mb-2 mr-2 -mt-5">
            <label class="vs-input--label pl-1">Месяц:</label>
            <datepicker
              v-model="selectedDate"
              class="datepicker_small"
              format="MMMM yyyy"
              minimumView="month"
              maximumView="year"
            />
          </div>
          <vs-button type="border" class="mb-2 mr-4" @click="openGeneratePopup" v-if="$can('rp.kv', 'write')">
            Сгенерировать
          </vs-button>
        </div>
        <div class="mb-4 flex justify-end">
          <label class="mr-4">только мои</label>
          <vs-switch v-model="showOnlyMyReestrHistory" />
        </div>
      </div>

      <vs-table :data="reestrHistoryFiltered" max-items="10" pagination class="w-full" noDataText="История пуста">
        <template slot="thead">
          <vs-th>Дата и время</vs-th>
          <vs-th>Ошибок</vs-th>
          <vs-th>Автор</vs-th>
          <vs-th />
        </template>

        <template slot-scope="{data}" ref="content">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ $options.filters.moment(tr.created_at, 'DD.MM.YYYY HH:mm:ss') }}</vs-td>
            <vs-td>{{ tr.log ? tr.log.errors_qty : '-' }}</vs-td>
            <vs-td>{{ tr.user ? tr.user.name : 'Не известно' }}</vs-td>
            <vs-td>
              <a :href="(tr.path + '?' + Date.now()) | imgPath" download target="_blank" @click.stop>
                <feather-icon icon="DownloadIcon" />
              </a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-popup
        :active.sync="generatePopupActive"
        title="Генерация исходящего реестра Сбербанка"
        class="employee-generate-reestr-popup"
      >
        <SelectBuildings
          v-model="buildings"
          class="employee-generate-reestr-popup__select-buildings"
          :danger.sync="isBuildingsError"
        />
        <div style="margin-top: 15px; text-align: center">
          <vs-button color="success" type="border" @click.stop="generateReestr">Сгенерировать</vs-button>
        </div>
      </vs-popup>

    </vs-popup>
  </div>
</template>

<script>
import SelectBuildings from "@/components/calculated-program/reports/components/SelectBuildings";
import notifyHttpError from "@/mixins/notifyHttpError";

export default {
  name:       "GenerateReestrSberbankPopup",
  mixins:     [notifyHttpError],
  components: {
    SelectBuildings,
  },
  data() {
    return {
      reestrHistory:           [],
      showOnlyMyReestrHistory: false,
      active:                  false,
      generatePopupActive:     false,
      buildings:               [],
      isBuildingsError:        false,
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
    selectedDate: {
      get() {
        return this.$store.getters['appUser/selectedDate'];
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },
    reestrHistoryFiltered() {
      let history = this.reestrHistory;
      if (this.showOnlyMyReestrHistory) {
        history = history.filter(historyLocal => historyLocal.user && historyLocal.user.id === this.userId);
      }
      return history;
    },
    userId() {
      return this.$store.getters['appUser/id'];
    },
  },
  watch:    {
    selectedHouseId() {
      this.buildings = [this.selectedHouseId];
    },
  },
  methods:  {
    openGeneratePopup() {
      this.isBuildingsError = false;
      if (!this.buildings.length) {
        this.buildings = [this.selectedHouseId];
      }
      this.generatePopupActive = true;
    },
    async generateReestr() {
      if (!this.buildings.length) {
        this.isBuildingsError = true;
        return false;
      }

      let params = {
        buildings_ids: this.buildings.join(','),
        buildings_id:  this.selectedHouseId,
        month:         this.$options.filters.formatDate(this.selectedDate),
        users_id:      this.userId,
      };
      this.$vs.notify({ color: 'success', title: 'Ожидайте', text: 'Генарация началась' });
      this.generatePopupActive = false;
      this.$http.get('export_reestr_sber', { params }).then(
        ( { data } ) => this.reestrHistory.unshift(data),
        this.notifyHttpError
      );
    },
    async getReestrHistory() {
      let params = {
        buildings_id: this.selectedHouseId,
      };
      try {
        let { data } = await this.$http.get('export/history/reestr_sberbank', {
          params: params,
        });

        this.reestrHistory = data.files;
      } catch (e) {
        this.reestrHistory = [];
      }
    },
    open() {
      this.getReestrHistory();
      this.active = true;
    },
  },
};
</script>

<style lang="scss">
.employee-generate-reestr-popup {
  &__select-buildings {
    .select-buildings__label {
      display: block;
      text-align: center;
    }

    .select-buildings__text {
      white-space: normal;
    }
  }
}

</style>
